module.exports = __webpack_public_path__ + "media/images/home/main/aa/backup/4-c364212b6978b151cab434c6441a0786.png";